<template>
  <span @click="actualizar()" class="text-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="transparent"
          v-bind="attrs"
          v-on="on"
          :loading="loading"
        >
          <v-icon :color="color" left> mdi-refresh </v-icon>          
        </v-btn>
      </template>
        <span>{{ tooltip ? $utilidades.traduccion({ texto: tooltip }) : $utilidades.traduccion({ texto: text }) }}</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: "BtnActualizar",
  props: {
    rounded: {
      type: Boolean,
      default: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
    textButton: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Actualizar", //Utilidades.traduccion({ texto: "Nuevo", tag: "NUEVO" }),
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "info",
    },
    tooltip: {
      type: String,
      default: "",
    },
    loading: Boolean
  },
  components: {},
  methods: {
    actualizar() {
      this.$emit("actualizar");
    },
  },
};
</script>